import { Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const CreditCard = {
  Component: styled('div')`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: ${theme.space[4]};
  `,

  IconWrapper: styled('div')`
    display: block;
    margin: ${theme.space[4]} 0;

    &[data-icon-color='alert'] {
      color: ${theme.colors.status.alert.standard};
    }

    &[data-icon-color='error'] {
      color: ${theme.colors.status.error.standard};
    }

    &[data-icon-color='brand-2'] {
      color: ${theme.colors.build.brand2};
    }
  `,

  Subtitle: styled(Text)`
    color: ${theme.colors.build.darkLight};
    display: block;
    margin: ${theme.space[2]};
  `,
};
